import { useConfig as hook } from '@eika-infrastruktur/config-provider';

const defaultTexts = {
    advisorName: 'Sikkerhetseksperten',
    result: 'Resultat'
};

const introTexts = {
    title: 'Test hvor god du er på sikkerhet',
    ingress: 'Hvor god er du på sikkerhet? Ta testen og finn ut.'
};

const imageLinks = {
    intro: '/intro-bilde-link-som-skal-byttes-ut.png',
    introAlt: 'intro bilde',
    result: '/resultat-bilde-link-som-skal-byttes-ut.png',
    resultAlt: 'resultat bilde'
};

const buttonTexts = {
    start: 'Start quiz',
    next: 'Neste',
    back: 'Tilbake',
    showResult: 'Se resultat',
    tryAgain: 'Ta testen på nytt'
};

export interface Alternative {
    text: string;
    description: string;
    score: number;
    nr: number;
}

export interface Question {
    question: string;
    nr: number;
    alternatives: Alternative[];
}

const defaultQuestions: Question[] = [];

interface Result {
    title: string;
    ingress: string;
    description?: string;
    pointsMinimum: number;
}

const defaultResults: Result[] = [];

interface Link {
    target?: string;
    text?: string;
    url: string;
}

interface Config {
    links: {
        disclaimerLink?: Link;
    };
    texts: typeof defaultTexts;
    buttons: typeof buttonTexts;
    intro: typeof introTexts;
    questions: Question[];
    results: Result[];
    images: typeof imageLinks;
}

export const defaultConfig: Config = {
    links: {},
    texts: defaultTexts,
    questions: defaultQuestions,
    results: defaultResults,
    buttons: buttonTexts,
    intro: introTexts,
    images: imageLinks
};

export const useConfig = () => hook<typeof defaultConfig>();
